export default "__VITE_ASSET__BPAZzOf5__"